<template>
  <div>
    <div v-if="!isSuccess">
      <div class="d-flex align-items-center pb-3">
        <b-avatar src="https://i.pravatar.cc/300" text="JD" size="2.5rem" class="mr-3" />
        <div>
          <div><strong>John Doe</strong></div>
        </div>
      </div>
      <div class="pb-2">
        <b-form-textarea id="contentShareText" v-model="contentShareText" rows="5" max-rows="5" />
        <b-alert class="mt-2" v-if="errorText" variant="danger" show>
          {{ errorText }}
        </b-alert>
      </div>
      <content-share-image v-if="displayContent === 'image'" :shareText="contentShareText" :url="url"
        :imageURL="imageURL || 'https://placehold.co/600x600'" :loading="false" :showShareText="false" :spacing="'p-0'" />
      <content-share-link v-if="displayContent === 'link'" :title="title" :url="url"
        :imageURL="imageURL || 'https://placehold.co/108x72'" :loading="false" />
      <b-row class="pr-3 pt-4 justify-content-end">
        <b-button type="submit" variant="primary" :disabled="isLoading" @click.prevent="sumbmitPost">
          <div class="d-flex justify-content-center align-items-center">
            <span>Post to LinkedIn</span>
            <b-spinner class="ml-2" v-if="isLoading" variant="primary" label="Loading" small />
          </div>
        </b-button>
      </b-row>
    </div>
    <div v-else>
      <b-row>
        <b-col class="p-4 text-center">
          <h2>Congrats! 🎉</h2>
          <p>You successfully created your post, click the following link to see it in your activity feed: <a
              href="https://www.linkedin.com/in/me/recent-activity/all/"
              target="_blank">https://www.linkedin.com/in/me/recent-activity/all/</a></p>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import ContentShareImage from '@/components/content-share/content-share-editor/ContentShareImage';
import ContentShareLink from '@/components/content-share/content-share-editor/ContentShareLink';

export default {
  props: {
    contentShare: {
      type: Object,
    },
    campaignID: {
      type: String,
      default: null,
    },
  },
  components: {
    ContentShareImage,
    ContentShareLink
  },
  data() {
    const { contentShare } = this;
    const { customFields, imageURL, title, url, image, id } = contentShare || {};
    const { displayContent, contentShareText } = customFields || {};
    const { fileLocation } = image || {};

    return {
      displayContent: displayContent || 'link',
      contentShareText: contentShareText || '🚀 Excited to share this content! 🌟',
      imageURL: fileLocation || imageURL,
      title,
      url,
      errorText: null,
      isSuccess: false,
      isLoading: false,
      entryID: id
    };
  },
  watch: {
    contentShareText() {
      if (this.contentShareText.length > 3) {
        this.errorText = null;
      }
    },
  },
  methods: {
    async sumbmitPost() {
      const { contentShareText, campaignID, contentShare } = this;
      if (!contentShareText || contentShareText.length < 4) {
        this.errorText = 'Make sure your text is at least 3 characters.';
        return;
      }

      const CreateLinkedInPost = gql`
        mutation CreateLinkedInPost($input: CreateLinkedInPostInput!) {
          createLinkedInPost(input: $input) {
            postURN
            status
          }
        }
      `;

      this.isLoading = true;
      try {
        const { data } = await this.$apollo.mutate({
          mutation: CreateLinkedInPost,
          variables: {
            input: {
              campaignID,
              contentShareID: contentShare.id,
              shareText: contentShareText
            }
          },
        });
        const { createLinkedInPost: response } = data || {};

        if (!response || response.status === 'ERROR') {
          this.$notification({
            message: 'Sorry, your request has failed.',
            variant: 'danger',
            toaster: 'b-toaster-top-center',
            title: 'Post creation failed'
          });
        }
        if (response && response.status === 'SUCCESS') {
          this.$emit('track', { channel: 'linkedin-api' });
          this.isSuccess = true;
        }
      } catch (error) {
        console.log(error);
        this.$notifyErr(error);
      }
      this.isLoading = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/content-share/LinkedInPostEditor.vue